import React from "react";
import ReactDOM from "react-dom";
// import './index.less';
import "./example.css";
import ExampleApp from "./ExampleApp";
import reportWebVitals from "./reportWebVitals";
import "react-mosaic-component/react-mosaic-component.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

ReactDOM.render(
  <ExampleApp ref={register_listeners} />,
  document.getElementById("app")
);

function parse_text_fragment(link: any) {
  var hash_parts = link.split(":~:text=");
  if (hash_parts.length == 2) {
    return decodeURIComponent(hash_parts[1]);
  } else {
    return "";
  }
}

function register_listeners(app: ExampleApp) {
  // Capture clicks of /browse/ urls and load them into reading pane instead of
  // opening a new tab.
  document.onclick = function (e: MouseEvent) {
    var event = e as PointerEvent;
    console.log(event);

    // @ts-ignore
    var path = event.path || event.composedPath();
    if (!path[0].attributes["href"]) {
      return;
    }
    var href = path[0].attributes["href"].textContent;
    if (href.includes("omnilabs.ai") && !href.includes("/browse")) {
      return;
    }
    var title = path[0].textContent;
    var text = parse_text_fragment(path[0].hash);
    e.preventDefault();
    // TODO balance.
    app.addToRight({ url: href, title: title, retrieval: text });
  };
}


function showExtensionDiv(){
  let under_sidebar = document.getElementById("under_sidebar");
  if (under_sidebar){
    under_sidebar.style.visibility = 'visible'
  }
}

window.onload = function(){
  setTimeout(showExtensionDiv, 1000);
}

// import React from "react";
// import ReactDOM from "react-dom";
// import { Mosaic, MosaicWindow } from "react-mosaic-component";

// import "@blueprintjs/core/lib/css/blueprint.css";
// import "@blueprintjs/icons/lib/css/blueprint-icons.css";

// import "./index.css"

// const ELEMENT_MAP: { [viewId: string]: JSX.Element } = {
//   a: <div>Left Window</div>,
//   b: <div>Top Right Window</div>,
//   c: <div>Bottom Right Window</div>
// };

// export const App = () => (
//   <Mosaic<string>
//     renderTile={(id, path) => (
//       <MosaicWindow title="Window" path={path}>
//         {ELEMENT_MAP[id]}
//       </MosaicWindow>
//     )}
//     initialValue={{
//       direction: "row",
//       first: "a",
//       second: {
//         direction: "column",
//         first: "b",
//         second: "c"
//       },
//       splitPercentage: 40
//     }}
//   />
// );

// const rootElement = document.getElementById("app");

// ReactDOM.render(<App />, rootElement);
